import { createUseStyles } from 'react-jss';
const useToastStyles = createUseStyles((theme) => ({
    base: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '8px',
        paddingRight: '24px',
        gap: '10px',
        borderRadius: '12px'
    },
    baseLine: {
        minHeight: '49px',
        width: '6px',
        borderRadius: '6px'
    },
    error: {
        backgroundColor: theme.colors.error.light,
        color: theme.colors.error.main
    },
    errorLine: {
        backgroundColor: theme.colors.error.main
    },
    success: {
        backgroundColor: theme.colors.success.light,
        color: theme.colors.success.main
    },
    successLine: {
        backgroundColor: theme.colors.success.main
    },
    info: {
        backgroundColor: '#ebf6ff',
        color: '#0094ff'
    },
    infoLine: {
        backgroundColor: '#0094ff'
    },
    warning: {
        backgroundColor: '#fef08a',
        color: '#854d0e'
    },
    warningLine: {
        backgroundColor: '#eab308'
    }
}));
export default useToastStyles;
